import React from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import { fetchDocuments } from "actions/documentsActions";
import TrackSsoUrlComponent from "components/common/TrackSsoUrlComponent";
import { getShortLivedToken } from "actions/loginActions";
import messages from "../messagesDescription";

const DocumentList = ({ category, intl }) => {
  if (!category) {
    return null;
  }

  return (
    <div>
      <h3>
        {intl.formatMessage({
          id: category.category,
          defaultMessage: category.category,
        })}
      </h3>
      <ul>
        {category.items.map(item => (
          <li key={item.documentName || item.documentPath || item.content}>
            {item.linkType === "Document" ? (
              <a
                className="c-action"
                href={item.documentPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({
                  id: item.content,
                  defaultMessage: item.content,
                })}
              </a>
            ) : (
              <a href={item.documentPath} target={item.target}>
                {intl.formatMessage({
                  id: item.content,
                  defaultMessage: item.content,
                })}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

const CommonDocuments = ({ type, fetchDocuments, documents, error, intl }) => {
  React.useEffect(() => {
    fetchDocuments(type);
  }, [type, fetchDocuments]);

  const dispatch = useDispatch();
  const fetchShortLivedToken = () => dispatch(getShortLivedToken());

  const { formatMessage } = intl;
  let documentGroups;

  if (documents && documents.categoryList) {
    documentGroups = documents.categoryList.map(category => (
      <DocumentList key={category.category} category={category} intl={intl} />
    ));
  } else {
    documentGroups = (
      <p>{formatMessage({ id: "noDocDescription", defaultMessage: "No Document available." })}</p>
    );
  }

  return (
    <div>
      <h2>{formatMessage(messages.benefitDocDescription)}</h2>
      <TrackSsoUrlComponent getShortLivedToken={fetchShortLivedToken} />
      {documentGroups}
      {error && (
        <p>
          {formatMessage({
            id: error.message,
            defaultMessage: error.message,
          })}
        </p>
      )}
    </div>
  );
};

DocumentList.propTypes = {
  category: PropTypes.object,
  intl: intlShape.isRequired,
};

CommonDocuments.propTypes = {
  type: PropTypes.string.isRequired,
  fetchDocuments: PropTypes.func.isRequired,
  documents: PropTypes.object,
  error: PropTypes.object,
  intl: intlShape.isRequired,
};

const mapStateToProps = ({ benefitsDocuments: { error, documents } }) => ({
  error,
  documents,
});

const mapDispatchToProps = {
  fetchDocuments,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CommonDocuments));



// WEBPACK FOOTER //
// ./components/common/Documents.js